import { useEffect } from 'react';

/**
 * Sets `document.title` as a side effect. Assigning to `document.title` directly
 * in a component body is an impure render (flagged by the React Compiler / Rules
 * of React), so views drive the title through this hook instead.
 *
 * A falsy title is a no-op, so callers with an optional/not-yet-known title
 * (e.g. a title derived from data that hasn't loaded) can call it unconditionally.
 */
export const useDocumentTitle = (title: string | undefined): void => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);
};
